import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getLinehaulReasons,getLinehaulReasonsbyId,postLinehaulReasons,
    editLinehaulReasons,exportLinehaulReasons,deleteLineHaulsbyId,getPlReasons,
    getPlReasonsbyId,postPlReasons,editPlReasons,exportPlReasons,deletePlbyId} from "../../services/Reasons/Linehaulreason_services"
const initialValues = {
 
};
let lineHaulStore = () => ({
  ...initialValues,
      getLinehaulReasons: async (params) => {
        const response = await getLinehaulReasons(params);
        return response;
      },
      getLinehaulReasonsbyId: async (params) => {
        const response = await getLinehaulReasonsbyId(params);
        return response;
      },
      postLinehaulReasons: async (params) => {
        const response = await postLinehaulReasons(params);
        return response;
      },
      editLinehaulReasons: async (params,data) => {
        const response = await editLinehaulReasons(params,data);
        return response;
      },
      exportLinehaulReasons: async (params) => {
        const response = await exportLinehaulReasons(params);
        return response;
      },
      deleteLineHaulsbyId: async (params) => {
        const response = await deleteLineHaulsbyId(params);
        return response;
      },
      getPlReasons: async (params) => {
        const response = await getPlReasons(params);
        return response;
      },
      deleteLineHaulsbyId: async (params) => {
        const response = await deleteLineHaulsbyId(params);
        return response;
      },
      getPlReasonsbyId: async (params) => {
        const response = await getPlReasonsbyId(params);
        return response;
      },
      postPlReasons: async (params) => {
        const response = await postPlReasons(params);
        return response;
      },
      editPlReasons: async (params,data) => {
        const response = await editPlReasons(params,data);
        return response;
      },
      exportPlReasons: async (params) => {
        const response = await exportPlReasons(params);
        return response;
      },
      deletePlbyId: async (params) => {
        const response = await deletePlbyId(params);
        return response;
      },
});

lineHaulStore = devtools(lineHaulStore);

export const useLinehaulStore = create(lineHaulStore);